import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { PremoTreeComponent } from 'src/app/shared/component/tree/premo-tree.component';
import { TreeModule } from 'enel-tree/dist/enel-tree';

@NgModule({
  declarations: [PremoTreeComponent],
  exports: [PremoTreeComponent],
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatRippleModule,
    TreeModule,
  ],
})
export class PremoTreeModule {}
